<template>
  <el-dialog
    :title="userId === null ? '新增帳號' : '編輯帳號'"
    :visible.sync="innerVisible"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <!--<el-form-item label="單位" :label-width="formLabelWidth" >-->
      <!--<el-input :value="myownOrg" readonly autocomplete="off"></el-input>-->
      <!--</el-form-item>-->

      <el-form-item label="帳號" :label-width="formLabelWidth" prop="username">
        <el-input
          v-model="form.username"
          :readonly="userId === null ? false : true"
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item label="名稱" :label-width="formLabelWidth" prop="name">
        <el-input v-model="form.name" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="密碼" :label-width="formLabelWidth" prop="password">
        <el-input
          type="password"
          v-model="form.password"
          :placeholder="userId === null ? '' : '******'"
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="確認密码"
        prop="checkPassword"
        :label-width="formLabelWidth"
      >
        <el-input
          type="password"
          v-model="form.checkPassword"
          :placeholder="userId === null ? '' : '******'"
          autocomplete="off"
        ></el-input>
      </el-form-item>

      <el-form-item :label="adminTitle" :label-width="formLabelWidth">
        <el-switch
          v-model="form.isAdmin"
          active-text="是"
          inactive-text="否"
          :disabled="userId === myUserId"
        ></el-switch>
      </el-form-item>

      <el-form-item v-if="!isMyownOrgSys" label="音檔檢查員" :label-width="formLabelWidth">
        <el-switch
          v-model="form.isAudit"
          active-text="是"
          inactive-text="否"
        ></el-switch>
      </el-form-item>

      <!--<el-form-item :label-width="formLabelWidth">-->
      <!--<el-switch v-model="form.isAdmin" :active-text="adminTitle"></el-switch>-->
      <!--</el-form-item>-->
    </el-form>

    <template #footer class="dialog-footer">
      <el-button @click="innerVisible = false">取 消</el-button>
      <el-button type="primary" @click="submit">確 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import { SYS_ORG_NAME, SYS_ADMIN_ROLE, ORG_ADMIN_ROLE, AUDITOR_ROLE } from "@/appConfig";
export default {
  model: {
    prop: "visible",
    event: "toggleVisible",
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: Number,
      default: null,
    },
  },
  computed: {
    isMyownOrgSys() {
      return this.myownOrg === SYS_ORG_NAME;
    },
    adminTitle() {
      return this.isMyownOrgSys ? "超級管理員" : "單位管理員";
    },
    ...mapGetters({
      myownOrg: "auth/orgName",
      myUserId: "auth/user_id",
    }),
    innerVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("toggleVisible", val);
      },
    },
  },
  data() {
    const validateUsername = (rule, value, callback) => {
      if (this.userId !== null) {
        const data = this.$store.getters["user/getUserById"](this.userId);
        if (data.username === value) {
          callback();
          return;
        }
      }
      this.$store.dispatch("user/isUsernameValid", value).then(res => {
        if (res) {
          callback();
        } else {
          callback(new Error("此帳號已經被使用"));
        }
      });
    };
    var validatePass = (rule, value, callback) => {
      if (value === "" && this.userId == null) {
        callback(new Error("請輸入密碼"));
      } else {
        if (this.form.checkPassword !== "") {
          this.$refs.form.validateField("checkPassword");
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "" && this.userId == null) {
        callback(new Error("請再次輸入密碼"));
      } else if (value !== this.form.password) {
        callback(new Error("兩次輸入密碼不一致!"));
      } else {
        callback();
      }
    };
    return {
      rules: {
        username: [
          { required: true, message: "請輸入帳號", trigger: "blur" },
          { validator: validateUsername, trigger: "blur" },
        ],
        name: [{ required: true, message: "請輸入名稱", trigger: "blur" }],
        password: [
          //{ required: true, message: '請輸入管理密碼', trigger: 'blur' },
          { validator: validatePass, trigger: "blur" },
        ],
        checkPassword: [
          //{ required: true, message: '請確認管理密碼', trigger: 'blur' },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
      formLabelWidth: "100px",
      form: {
        username: "",
        name: "",
        password: "",
        checkPassword: "",
        isAdmin: false,
        isAudit: false,
      },
    };
  },
  created() {
    if (this.innerVisible) {
      if (this.userId !== null) {
        const data = this.$store.getters["user/getUserById"](this.userId);
        this.form.id = data.id;
        this.form.username = data.username;
        this.form.name = data.name;
        this.form.isAdmin = this.isAdminUser(data.roles);
        this.form.isAudit = this.isAuditor(data.roles);
      }
    }
  },
  methods: {
    isAdminUser(roles) {
      const adminRole = this.isMyownOrgSys ? SYS_ADMIN_ROLE : ORG_ADMIN_ROLE;
      return roles.includes(adminRole);
    },
    isAuditor(roles) {
      return roles.includes(AUDITOR_ROLE);
    },
    submit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.userId !== null) {
            this.submitUpdate();
          } else {
            this.submitAdd();
          }
        } else {
          return false;
        }
      });
    },
    submitAdd() {
      this.$store.dispatch("user/add", this.form).then(() => {
        this.innerVisible = false;
        this.$store.dispatch("user/list", null);
      });
    },
    submitUpdate() {
      this.$store.dispatch("user/update", this.form).then(() => {
        this.innerVisible = false;
        this.$store.dispatch("user/list", null);
      });
    },
  },
};
</script>

<style></style>
